module.exports = __webpack_public_path__ + "img/character_cv.0c649b52.png";